import {NgxMaskOptions} from 'ngx-mask';

import {toEnglishDigits} from '@app/core/utils/digit.util';

export const ngxMaskConfig: NgxMaskOptions = {
  inputTransformFn: value => toEnglishDigits(value),
};
